import React, {useEffect, useState} from 'react'
import {Button, Image, Layout, Tag, Modal, Input} from 'antd'
import {useHistory} from 'react-router-dom'
import {PlusOutlined, ArrowLeftOutlined} from '@ant-design/icons'
import './course.less'
import {ObsKeyToURL} from '../../api/utils'
import {Lesson, LessonAnnex, newCourse, newCourseAnnex} from '../../api/course'
import API from '../../api'
import {CourseAnnexCom} from './annex'
import InputFile from '../InputFile'
import {FileInfo, newFileInfo} from '../../api/file_info'
import {newUser, User} from '../../api/user'
import SearchBar from 'components/SearchBar'
import EmptyCom from '../Empty'

const {Sider, Content} = Layout

// 课程页面
const CourseCom = () => {
  const history = useHistory()

  // 当前选择课件类型
  const [currentType, setCurrentType] = useState('')

  // 附件列表
  const [annexes, setAnnexes] = useState<LessonAnnex[]>([])

  // 课程数量
  const [total, setTotal] = useState(0)
  // 当前课程
  const [lesson, setLesson] = useState<Lesson>(newCourse())

  // 根据当前选择课件类型获取列表
  useEffect(() => {
    switch (currentType) {
      case 'all':
        setAnnexes([
          ...lesson.coursewares!,
          ...lesson.lesson_plans!,
          ...lesson.videos!,
          ...lesson.codes!,
          ...lesson.exams!,
        ])
        break
      case 'courseware':
        setAnnexes([...lesson.coursewares!])
        break
      case 'lesson_plan':
        setAnnexes([...lesson.lesson_plans!])
        break
      case 'video':
        setAnnexes([...lesson.videos!])
        break
      case 'code':
        setAnnexes([...lesson.codes!])
        break
      case 'exams':
        setAnnexes([...lesson.exams!])
        break
      default:
        setAnnexes([
          ...lesson.coursewares!,
          ...lesson.lesson_plans!,
          ...lesson.videos!,
          ...lesson.codes!,
          ...lesson.exams!,
        ])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentType])

  const [grade_id, setGrade] = useState(0)

  const [addVisible, setAddVisible] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [user, setUser] = useState<User>(newUser())
  useEffect(() => {
    // 加载课程内容

    const state: any = history.location.state

    setTotal(state.total)
    setLesson({...lesson, ...state.course})
    if (state.grade_id !== undefined) {
      setGrade(parseInt(state.grade_id))
    }
    // 获取用户信息
    setUser(JSON.parse(sessionStorage.getItem('user-info') || '{}'))
    let u = JSON.parse(sessionStorage.getItem('user-info') || '{}')
    if (u.type === 'guest') {
      setDisabled(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    updateCourseAnnexList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lesson.id])

  const [uploadFile, setUploadFile] = useState<FileInfo>(newFileInfo())

  // 更新课程附件列表
  const updateCourseAnnexList = () => {
    if (lesson.id === 0) {
      return
    }
    API.listLessonAnnex(lesson.id).then(res => {
      let annexes: LessonAnnex[] = res.data.annexes
      if (annexes !== null) {
        let coursewares: LessonAnnex[] = []
        let lesson_plans: LessonAnnex[] = []
        let videos: LessonAnnex[] = []
        let codes: LessonAnnex[] = []
        let exams: LessonAnnex[] = []
        annexes.forEach(ann => {
          ann.key = ann.lesson_annex_id
          switch (ann.type) {
            case 'lesson_plan':
              lesson_plans.push(ann)
              break
            case 'courseware':
              coursewares.push(ann)
              break
            case 'video':
              videos.push(ann)
              break
            case 'code':
              codes.push(ann)
              break
            case 'exam':
              exams.push(ann)
              break
          }
        })
        setLesson({
          ...lesson,
          // ...state.course,
          coursewares: coursewares,
          lesson_plans: lesson_plans,
          videos: videos,
          codes: codes,
          exams: exams,
        })
        if (currentType === 'all') {
          setCurrentType('AllType')
        } else {
          setCurrentType('all')
        }
      }
    })
  }

  const changeFileName = e => {
    setUploadFile({...uploadFile, name: e.target.value})
  }
  // 打开上传框
  const showAddModal = () => {
    setAddVisible(true)
  }

  // 获取上传类型
  const getAnnexType = (suffix: string) => {
    switch (suffix) {
      case 'doc':
      case 'docx':
      case 'pdf':
        return {name: '教案', value: 'lesson_plan'}
      case 'ppt':
      case 'pptx':
        return {name: '课件', value: 'courseware'}
      case 'mp4':
        return {name: '视频', value: 'video'}
      case 'sb3':
        return {name: '程序', value: 'code'}
      default:
        return {name: '', value: ''}
    }
  }

  // 添加课程附件
  const handleAdd = () => {
    let annex = newCourseAnnex()
    annex.lesson_id = lesson.id
    annex.name = uploadFile.name
    annex.suffix = uploadFile.suffix
    annex.url = uploadFile.url
    annex.type = getAnnexType(uploadFile.suffix).value
    annex.author.user_id = user.user_id

    API.addCourseAnnex(annex).then(res => {
      updateCourseAnnexList()
      setAddVisible(false)
    })
  }

  const handleCancel = () => {
    setAddVisible(false)
  }

  const courseBack =()=>{
    if (grade_id === undefined || grade_id === 0) {
      history.goBack()
    } else {
      history.push('/grades/' + grade_id)
    }
  }


  return (
    <>
      <div style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/course-banner.png)`}}>
        <SearchBar module="Course Center" />
      </div>
      <div className="layout-content-mask">
        <div className="layout-content-bg-LB"></div>
        <div className="layout-content-bg-RT"></div>
        <div className="course-container" style={{paddingBottom: 45}}>
          <div
            className="course-container-header"
            onClick={courseBack}
          >
            <ArrowLeftOutlined />
            <div className="second-title course-container-header-text">返回</div>
          </div>
          <Layout className="course-desc-layout">
            <Sider width={300} theme="light" className="course-container-sider">
              <Image
                preview={false}
                width={300}
                height={200}
                src={`${ObsKeyToURL(lesson.image)}`}
                className="course-container-sider-image"
              ></Image>
            </Sider>
            <Content className="course-desc-content" key="desc-content">
              {/* 标题 */}
              <div className="course-desc-content-header">
                <div className="title bold" style={{color: '#40A9FF'}}>
                  {lesson.name}
                </div>
                <div style={{color: '#8C8C8C'}}>第 {lesson.renderSort} 课时</div>
              </div>
              {/* 介绍 */}
              <div className="course-desc-text-group">
                <div className="course-desc-text">{lesson.desc}</div>
              </div>
              {/* 标签 */}
              <div className={`course-tag-list-group ${lesson.tags === '' ? 'hide' : ''}`}>
                {lesson.tags!.split(' ').map((t, index) => (
                  <Tag key={index + 'tag'}>{t}</Tag>
                ))}
              </div>
            </Content>
          </Layout>

          {/* 课件 教案 及 视频 */}
          <div className="title bold" style={{color: '#262626', marginBottom: 16}}>
            课程详情
          </div>
          <div className="annex-header">
            <div className="annex-type-group">
              <div
                className={`annex-type ${currentType === 'all' ? 'annex-type-active' : ''}`}
                onClick={() => setCurrentType('all')}
              >
                全部类型
              </div>
              <div
                className={`annex-type ${currentType === 'lesson_plan' ? 'annex-type-active' : ''}`}
                onClick={() => setCurrentType('lesson_plan')}
              >
                教案
              </div>
              <div
                className={`annex-type ${currentType === 'courseware' ? 'annex-type-active' : ''}`}
                onClick={() => {
                  setCurrentType('courseware')
                }}
              >
                课件
              </div>
              <div
                className={`annex-type ${currentType === 'video' ? 'annex-type-active' : ''}`}
                onClick={() => setCurrentType('video')}
              >
                视频
              </div>
              <div
                className={`annex-type ${currentType === 'code' ? 'annex-type-active' : ''}`}
                onClick={() => setCurrentType('code')}
              >
                程序
              </div>
              <div
                className={`annex-type ${currentType === 'exercises' ? 'annex-type-active' : ''}`}
                onClick={() => setCurrentType('exams')}
              >
                课堂评测
              </div>
            </div>
            <Button onClick={showAddModal} disabled={disabled} className="upload-button">
              添加
              <PlusOutlined />
            </Button>
          </div>
          {annexes.length === 0 ? (
            <EmptyCom fn={showAddModal} />
          ) : (
            <CourseAnnexCom
              annexes={annexes}
              course={lesson}
              total={total}
              grade_id={grade_id}
              updateCourseAnnexList={updateCourseAnnexList}
            />
          )}
        </div>
      </div>
      {/* 上传课件Modal */}
      <Modal
        width="814px"
        title="请上传您的作品-课件/教案/视频"
        visible={addVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel-btn" onClick={handleCancel}>
            取消
          </Button>,
          <Button key="confirm-btn" onClick={handleAdd} type="primary">
            上传
          </Button>,
        ]}
      >
        <div className="upload-file-group">
          <InputFile initFile={uploadFile} keyPrefix="course/annex/" setFile={setUploadFile} />
          <div
            style={{
              width: 360,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            文件名:
            <Input value={uploadFile.name} onChange={changeFileName} style={{width: 300}} />
          </div>
          <div style={{width: 120}}>上传到: {API.getCourseAnnexType(uploadFile.suffix).name}</div>
        </div>
      </Modal>
    </>
  )
}

export default CourseCom
